// eslint-disable
import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { GET_BARANGAYS } from './constant';
import { getBarangays } from './actions';

const makeListSelector = () =>
  createSelector(
    ({ api }, name) => _.get(api, `${GET_BARANGAYS}/${name}.list`) || [],
    list =>
      list.map(item => ({
        label: _.get(item, 'attributes.name'),
        value: _.get(item, 'id'),
        fullInfo: item,
      }))
  );

const Barangay = ({
  name,
  regionCode,
  provinceCode,
  municipalityCode,
  onChange,
  value,
  styles,
  isDisabled,
  readOnly,
}) => {
  const dispatch = useDispatch();
  const selectList = useMemo(makeListSelector, []);
  const isLoading = useSelector(
    ({ api }) => api.loading.indexOf(`${GET_BARANGAYS}/${name}`) > -1
  );
  const list = useSelector(state => selectList(state, name));

  const findValue =
    list.find(item => _.get(item, 'fullInfo.attributes.code') === value) || '';

  useEffect(() => {
    if (municipalityCode)
      dispatch(
        getBarangays(name, regionCode, provinceCode, municipalityCode, {
          display_all: 1,
        })
      );
  }, [municipalityCode]);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <Select
      placeholder="- Select -"
      isClearable
      isDisabled={isDisabled}
      isLoading={isLoading}
      styles={styles}
      value={findValue}
      onChange={onChange}
      options={municipalityCode ? list : []}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

Barangay.defaultProps = {
  name: undefined,
  styles: {},
  readOnly: undefined,
  isDisabled: false,
};

Barangay.propTypes = {
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  regionCode: PropTypes.string.isRequired,
  provinceCode: PropTypes.string.isRequired,
  municipalityCode: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  styles: PropTypes.instanceOf(Object),
};

export default Barangay;
